export default "__VITE_ASSET__CakDawVJ__"